// src/components/store/sections/faqs/FaqV24OrigamifaqTealLagoon.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV24OrigamifaqTealLagoon(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={24}
      archKey="origami_faq"
      archLabel="Origami Ribbon Panels"
      palName="TealLagoon"
      grad="from-teal-500 via-cyan-600 to-emerald-700"
      lightBg="bg-teal-50"
      textCol="text-teal-700"
      borderCol="border-teal-200"
      btnCls="bg-teal-600 hover:bg-teal-700"
      hexCol="#14b8a6"
      {...props}
    />
  );
}
